import { mappedRole, UserRole } from "@/constants/users/userRole"

export const SelectInputField = {
  getPlaceHolderText: (fieldValue: string | undefined, defaultValue: string) => {
    if (fieldValue) {
      return fieldValue
    } else {
      return defaultValue
    }
  },
  getFormattedOption: (option: string) => {
    if (option as UserRole === UserRole.ADMIN) {
      return mappedRole[UserRole.ADMIN]
    } else if (option as UserRole === UserRole.USER) {
      return mappedRole[UserRole.USER]
    }
    return option
  }
}
